import React, {useEffect, useState, useMemo} from "react";
import {Input, Select} from "antd";
import {
    SearchText,
    EquipmentTypeFilter,
    CityFilter,
    DynamicCityFilter,
    CourierActivityFilter,
    DateFilter,
    CourierActivationStepFilter,
    DateRangeFilter
} from "../../../_defaultComponents/FilterComponents";
import {ZoneSelect} from "../../../_defaultComponents/ZoneSelect/ZoneSelect";
import debounce from "lodash/debounce";
import {FiltersWrapper} from "../../../_defaultComponents/FilterComponents/FiltersWrapper";
import {FilterLabel} from "../../../_defaultComponents/FilterComponents/FilterComponentStyles";
import moment from "moment";
import { courierEmploymentTypes } from "constants/constants";

const Filters = ({setCurrentPage, filters, setFilters}) => {
    const [zoneId, setZoneId] = useState(filters?.zoneId);
    const [searchText, setSearchText] = useState(filters?.searchText);
    const [preferredCityId, setPreferredCityId] = useState(filters?.preferredCityId);
    const [contractStatus, setContractStatus] = useState(filters?.contractStatus);
    const [assignmentStatus, setAssignmentStatus] = useState(filters?.assignmentStatus);
    const [courierActivity, setCourierActivity] = useState(filters?.courierActivity);
    const [handoveredDateRange, setHandoveredDateRange] = useState(
        filters?.handoveredStartDate && filters?.handoveredEndDate
            ? [filters?.handoveredStartDate, filters?.handoveredEndDate]
            : []
    );
    const [activationStep, setActivationStep] = useState(filters?.activationStep);
    const [employmentType, setEmploymentType] = useState(filters?.employmentType);

    const handleSearchTextChange = value => {
        setZoneId(undefined);
        setPreferredCityId(undefined);
        setContractStatus(undefined);
        setAssignmentStatus(undefined);
        setCourierActivity(undefined);
        setHandoveredDateRange([]);
        setActivationStep(undefined);
        setEmploymentType(undefined);
        setSearchText(value);
    };
    useEffect(() => {
        setCurrentPage(1);
    }, [
        zoneId,
        searchText,
        preferredCityId,
        contractStatus,
        assignmentStatus,
        courierActivity,
        JSON.stringify(handoveredDateRange),
        activationStep,
        employmentType
    ]);

    useEffect(() => {
        const newFilters = {
            zoneId: zoneId && zoneId !== "all" ? zoneId : undefined,
            searchText: searchText || undefined,
            preferredCityId:
                preferredCityId && preferredCityId !== "all" ? preferredCityId : undefined,
            contractStatus: contractStatus && contractStatus !== "all" ? contractStatus : undefined,
            assignmentStatus:
                assignmentStatus && assignmentStatus !== "all" ? assignmentStatus : undefined,
            courierActivity:
                courierActivity && courierActivity !== "all" ? courierActivity : undefined,
            handoveredStartDate: handoveredDateRange?.[0]
                ? moment(handoveredDateRange[0]).format("YYYY-MM-DD")
                : undefined,
            handoveredEndDate: handoveredDateRange?.[1]
                ? moment(handoveredDateRange[1]).format("YYYY-MM-DD")
                : undefined,
            activationStep: activationStep && activationStep !== "all" ? activationStep : undefined,
            employmentType: employmentType && employmentType !== "all" ? employmentType : undefined
        };
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
        }
    }, [
        zoneId,
        searchText,
        preferredCityId,
        contractStatus,
        assignmentStatus,
        courierActivity,
        JSON.stringify(handoveredDateRange),
        activationStep,
        employmentType
    ]);

    return (
        <FiltersWrapper gap={16} align="flex-end">
            <div className="filter-item">
                <FilterLabel>Bölge</FilterLabel>
                <ZoneSelect
                    value={zoneId}
                    onChange={setZoneId}
                    showAllOption={true}
                    allowClear={true}
                    showTitle={false}
                    marginBottom="0"
                />
            </div>

            <div className="filter-item">
                <FilterLabel>Şehir</FilterLabel>
                <DynamicCityFilter
                    value={preferredCityId}
                    onChange={setPreferredCityId}
                    showLabel={false}
                    selectMarginBottom="0px"
                    allowClear={true}
                />
            </div>

            <div className="filter-item">
                <FilterLabel>Sözleşme Durumu</FilterLabel>
                <Select value={contractStatus} onChange={setContractStatus}>
                    <Select.Option value="all">Tümü</Select.Option>
                    <Select.Option value="approved">Onaylı</Select.Option>
                    <Select.Option value="pending">Sözleşme Beklemede</Select.Option>
                    <Select.Option value="pendingApproval">Onay Bekliyor</Select.Option>
                </Select>
            </div>
            <div className="filter-item">
                <FilterLabel>Atama Durumu</FilterLabel>
                <Select value={assignmentStatus} onChange={setAssignmentStatus}>
                    <Select.Option value="all">Tümü</Select.Option>
                    <Select.Option value="assigned">Atandı</Select.Option>
                    <Select.Option value="pending">Atama Beklemede</Select.Option>
                </Select>
            </div>

            <div className="filter-item">
                <FilterLabel>Ara</FilterLabel>
                <SearchText
                    value={searchText}
                    onChange={handleSearchTextChange}
                    label="Ara"
                    placeholder="Kurye adı, TC, telefon"
                    showLabel={false}
                />
            </div>
            <div className="filter-item">
                <FilterLabel>Kurye Aktiflik Durumu</FilterLabel>
                <CourierActivityFilter
                    value={courierActivity}
                    onChange={setCourierActivity}
                    showLabel={false}
                    selectMarginBottom="0px"
                    allowClear={true}
                />
            </div>
            <div className="filter-item">
                <FilterLabel>Kurye Durumu</FilterLabel>
                <CourierActivationStepFilter
                    value={activationStep}
                    onChange={setActivationStep}
                    showLabel={false}
                    selectMarginBottom="0px"
                    allowClear={true}
                />
            </div>
            <div className="filter-item">
                <FilterLabel>Ekipman Atama Tarihi</FilterLabel>
                <DateRangeFilter
                    value={handoveredDateRange}
                    onChange={setHandoveredDateRange}
                    showLabel={false}
                    selectMarginBottom="0px"
                    allowClear={true}
                />
            </div>
            <div className="filter-item">
                <FilterLabel>Çalışma Şekli</FilterLabel>
                <Select
                    value={employmentType || "all"}
                    onChange={value => setEmploymentType(value === "all" ? undefined : value)}
                    allowClear
                >
                    <Select.Option value="all">Tümü</Select.Option>
                    {courierEmploymentTypes.map(type => (
                        <Select.Option key={type.value} value={type.value}>
                            {type.name}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        </FiltersWrapper>
    );
};

export default Filters;
